import React from 'react';
import { PerformanceLicenceBanner } from './PerformanceLicenceBanner';
import { redirectToOota } from '../../../utils/helpers';

const handleSubscribeClick = async (e) => {
  e.preventDefault();
  redirectToOota();
};

const PerformanceLicenceModal = () => (
  <div
    className="modal fade"
    id="performanceLicenceModal"
    tabIndex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div
      className="modal-dialog modal-dialog-centered"
      role="document"
      style={{ maxWidth: '700px' }}
    >
      <div className="modal-content">
        <div
          className="custom__modal__header "
          style={{ marginBottom: '-35px', marginRight: '15px' }}
        >
          <div className="float-right" />
          <a href="" className="custom__modal__close " data-dismiss="modal">
            <img src="/img/plus-icon.svg" alt="" />
          </a>
        </div>
        <PerformanceLicenceBanner onClick={handleSubscribeClick} />
      </div>
    </div>
  </div>
);

export default PerformanceLicenceModal;
